var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOffersUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 213,
    viewBox: "0 0 254 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1309_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8027 202.048C15.326 208.582 22.8035 211.387 22.8035 211.387C22.8035 211.387 24.5688 203.599 21.0456 197.065C17.5223 190.531 10.0448 187.726 10.0448 187.726C10.0448 187.726 8.2795 195.515 11.8027 202.048Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2242 199.899C20.585 203.726 23.0348 211.327 23.0348 211.327C23.0348 211.327 15.1716 212.724 8.81067 208.897C2.44978 205.07 0 197.469 0 197.469C0 197.469 7.86326 196.072 14.2242 199.899Z",
    fill: "#F07663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.836 10.1792H117.148V10.7462H156.836V10.1792Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.064 10.6044H145.497V15.8489H146.064V10.6044Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.771 10.6044H128.204V15.8489H128.771V10.6044Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.963 37.3935H137.275V37.9605H176.963V37.3935Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.615 32.2908H148.048V37.5353H148.615V32.2908Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.908 32.2908H165.341V37.5353H165.908V32.2908Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.691 50.1502H190.004V50.7172H229.691V50.1502Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.342 45.0475H200.775V50.2919H201.342V45.0475Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.635 45.0475H218.068V50.2919H218.635V45.0475Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.722 181.686H186.034V182.253H225.722V181.686Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.374 176.583H196.807V181.828H197.374V176.583Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.666 176.583H214.099V181.828H214.666V176.583Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.971 90.6881H118.283V91.2551H157.971V90.6881Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.622 85.5854H129.055V90.8299H129.622V85.5854Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.915 85.5854H146.348V90.8299H146.915V85.5854Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.443 159.007H130.756V159.574H170.443V159.007Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.094 153.905H141.527V159.149H142.094V153.905Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.387 153.905H158.82V159.149H159.387V153.905Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.942 138.313H194.255V138.88H233.942V138.313Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.595 133.21H205.028V138.455H205.595V133.21Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.887 133.21H222.32V138.455H222.887V133.21Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.638 199.057H35.5137V198.574H102.155V175.153H41.1567L38.1934 168.979L38.6289 168.77L41.4606 174.67H102.638V199.057Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4465 210.888C47.2469 210.888 49.5171 208.618 49.5171 205.817C49.5171 203.017 47.2469 200.747 44.4465 200.747C41.6461 200.747 39.376 203.017 39.376 205.817C39.376 208.618 41.6461 210.888 44.4465 210.888Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.428 210.888C97.2284 210.888 99.4986 208.618 99.4986 205.817C99.4986 203.017 97.2284 200.747 94.428 200.747C91.6276 200.747 89.3574 203.017 89.3574 205.817C89.3574 208.618 91.6276 210.888 94.428 210.888Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.343 101.267C155.077 101.267 156.482 99.8618 156.482 98.1282C156.482 96.3946 155.077 94.9893 153.343 94.9893C151.609 94.9893 150.204 96.3946 150.204 98.1282C150.204 99.8618 151.609 101.267 153.343 101.267Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.818 167.184H34.3692L18.0439 113.823H126.63L126.531 114.137L109.818 167.184ZM34.7264 166.702H109.463L125.972 114.306H18.6966L34.7264 166.702Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.927 164.408H37.6575L23.3184 117.082H118.693L118.607 117.361L103.927 164.408Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.982 109.056L127.515 108.932L130.701 96.9209H149.238V97.4039H131.073L127.982 109.056Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.203 130H23.3184V130.483H121.203V130Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.598 147.792H28.7617V148.275H115.598V147.792Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5767 114.064H72.0938V166.943H72.5767V114.064Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.198 114.049L90.7314 166.927L91.2134 166.958L94.6799 114.081L94.198 114.049Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4829 114.049L50.001 114.08L53.4474 166.959L53.9293 166.927L50.4829 114.049Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 211.194H0V211.761H254V211.194Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.788 17.5407C168.788 17.5407 172.932 29.3354 170.382 31.1499C167.832 32.9645 178.989 47.7834 178.989 47.7834L192.377 44.1543L185.046 31.7548C185.046 31.7548 184.089 19.3553 184.089 17.5407C184.089 15.7262 168.788 17.5407 168.788 17.5407Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M168.788 17.5407C168.788 17.5407 172.932 29.3354 170.382 31.1499C167.832 32.9645 178.989 47.7834 178.989 47.7834L192.377 44.1543L185.046 31.7548C185.046 31.7548 184.089 19.3553 184.089 17.5407C184.089 15.7262 168.788 17.5407 168.788 17.5407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.833 101.615C161.833 101.615 160.623 116.737 161.833 124.6C163.042 132.463 164.857 154.238 164.857 154.238C164.857 154.238 164.857 195.368 171.51 195.972C178.164 196.577 183.002 197.182 183.607 194.763C184.212 192.343 180.583 191.134 182.398 189.924C184.212 188.714 184.817 184.48 182.398 179.641C179.978 174.803 182.398 125.809 182.398 125.809L193.89 156.657C193.89 156.657 195.099 182.061 196.309 185.69C197.519 189.319 195.099 195.972 199.333 196.577C203.567 197.182 208.406 193.553 210.826 192.343C213.245 191.134 207.197 191.134 208.406 190.529C209.616 189.924 213.245 188.109 212.035 187.504C210.826 186.9 209.616 157.867 209.616 157.867C209.616 157.867 206.289 95.8692 202.055 93.4498C197.821 91.0304 195.099 95.1977 195.099 95.1977L161.833 101.615Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72 193.553V198.392C172.72 198.392 167.277 211.545 172.72 211.545C178.164 211.545 182.398 212.908 182.398 211.094V194.763L172.72 193.553Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.406 193.544V198.383C208.406 198.383 213.85 211.537 208.406 211.537C202.962 211.537 198.729 212.9 198.729 211.085V194.754L208.406 193.544Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.257 26.3111C183.269 26.3111 188.144 21.4367 188.144 15.4238C188.144 9.41087 183.269 4.53644 177.257 4.53644C171.244 4.53644 166.369 9.41087 166.369 15.4238C166.369 21.4367 171.244 26.3111 177.257 26.3111Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.929 35.6863C173.929 35.6863 176.954 44.7591 181.793 42.9446L186.631 41.13L195.099 99.1959C195.099 99.1959 188.446 108.874 178.768 102.825C169.091 96.7765 173.929 35.6863 173.929 35.6863Z",
    fill: "#F07663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.397 33.8718L185.119 28.1257C185.119 28.1257 201.148 35.6863 203.567 38.1057C205.987 40.5252 205.987 44.1543 205.987 44.1543L201.753 59.2756C201.753 59.2756 202.962 92.5425 202.962 93.7522C202.962 94.9619 207.196 101.615 204.172 99.1959C201.148 96.7765 200.543 94.3571 198.124 97.9862C195.704 101.615 190.261 105.849 190.261 105.849L182.397 33.8718Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.567 77.4212L201.752 94.3571C201.752 94.3571 190.865 104.035 193.284 104.64C195.704 105.244 196.914 102.825 196.914 102.825C196.914 102.825 201.148 107.059 203.567 104.64C205.986 102.22 212.035 79.2358 212.035 79.2358L203.567 77.4212Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.488 0.0368161C175.074 -0.0494673 172.491 -0.0921487 170.456 1.20851C169.52 1.86125 168.698 2.66517 168.026 3.58736C166.044 6.0929 164.331 9.24545 165.068 12.3541L165.923 12.0207C165.923 12.8505 165.738 13.6699 165.383 14.4197C165.503 14.0695 165.906 14.6355 165.798 14.9897L164.856 18.0798C166.405 17.5122 168.331 18.6615 168.567 20.2937C168.674 16.7045 169.047 12.5888 171.958 10.4872C173.427 9.42732 175.285 9.10377 177.073 8.81646C178.722 8.55141 180.451 8.29866 182.031 8.84165C183.611 9.38465 184.956 11.0004 184.598 12.6321C185.327 12.3811 186.141 12.8888 186.501 13.57C186.861 14.2512 186.88 15.0547 186.891 15.8251C187.667 16.3739 188.551 15.2842 188.868 14.3875C189.61 12.2829 190.271 10.0425 189.871 7.84675C189.47 5.65101 187.681 3.55264 185.449 3.5452C185.72 3.24763 185.865 2.85636 185.852 2.45415L184.013 2.29871C184.48 2.23259 184.909 2.00614 185.228 1.65817C184.489 2.4709 178.682 0.0795114 177.488 0.0368161Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.954 32.0572C176.954 32.0572 172.03 27.2321 170.258 27.5277C168.486 27.8233 166.067 32.0572 166.067 32.0572C166.067 32.0572 151.55 36.8961 152.155 41.7349C152.76 46.5737 159.413 70.163 159.413 70.163C159.413 70.163 164.857 98.5911 160.018 101.615C155.179 104.64 183.003 112.503 183.607 108.874C184.212 105.244 185.422 68.9533 183.607 63.5096C181.793 58.0659 176.954 32.0572 176.954 32.0572Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.124 41.7349H205.603C205.603 41.7349 210.826 64.7193 211.431 67.1387C212.036 69.5581 213.245 81.0503 212.64 81.0503C212.036 81.0503 199.939 78.6309 199.939 80.4455L198.124 41.7349Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.87 98.6518H169.239C166.445 85.7987 166.211 73.3803 169.239 61.5156H197.87C193.25 73.1669 192.961 85.5002 197.87 98.6518Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.599 82.8648L166.067 86.494C166.067 86.494 182.398 88.9134 182.398 82.26C182.398 75.6066 166.067 79.2357 166.067 79.2357L160.623 77.4951L157.599 82.8648Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.413 38.1058L152.154 39.9203L146.711 71.9775C146.711 71.9775 144.896 80.4455 147.92 81.0503C150.945 81.6552 159.413 86.494 159.413 86.494C159.413 86.494 160.622 77.4212 163.042 77.4212L156.993 72.5824L160.622 51.4126L159.413 38.1058Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7666 100.043H17.0791V100.61H56.7666V100.043Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4185 94.9404H27.8516V100.185H28.4185V94.9404Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7115 94.9404H45.1445V100.185H45.7115V94.9404Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6572 16.1324H30.9697V16.6993H70.6572V16.1324Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8853 16.5576H59.3184V21.802H59.8853V16.5576Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5924 16.5576H42.0254V21.802H42.5924V16.5576Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.628 71.9783H70.9404V72.5453H110.628V71.9783Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.856 72.4036H99.2891V77.648H99.856V72.4036Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.564 72.4036H81.9971V77.648H82.564V72.4036Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 71.6948H3.47266V72.2618H43.1602V71.6948Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3873 72.1201H31.8203V77.3645H32.3873V72.1201Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0953 72.1201H14.5283V77.3645H15.0953V72.1201Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7852 43.3466H51.0977V43.9136H90.7852V43.3466Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4371 38.244H61.8701V43.4884H62.4371V38.244Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7291 38.244H79.1621V43.4884H79.7291V38.244Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1309_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 212.037,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOffersUi);
export default __webpack_public_path__ + "static/media/No_offers_ui.6d3095a634afa877d81e4d710e99a1fd.svg";
export { ForwardRef as ReactComponent };